<template>
    <div class="tsbx">
        <div class="tsbxc">
            <div class="ygpjitem" @click="goxq(index,item.status)" v-for="(item,index) in list" :key="index">
               <div class="ygpjup">
                   <span>{{item.name}}</span>
               </div>
               <div class="ygpjdown">
                   <div class="dleft">
                       <span>物业工作：{{item.work}}</span>
                       <span>联系方式：{{item.phone}}</span>
                   </div>
                   <div class="dpj">
                       <span>{{item.status}}</span>
                   </div>
               </div>
            </div>
            
        </div>
    </div>
</template>
<script>
const axios = require('axios');
export default {
    data() {
        return {
            list:[
               /* {
                    name:'张三',
                    work:'巡逻员',
                    phone:'18876231232',
                    status:'待评价'
                }, */
            ]
        }
    },
    created () {

    },
    mounted() {
        
    },
    methods: {
        
        goxq(index,status){
            var that = this
            var st = status=='待评价' ? 0 :1
            that.$router.push({ path: "/wyfw/ygpj/xq", query: {id:index,status:st} });
        },
    },
}
</script>
<style lang="less" scoped>
    .tsbx{
        // height: 100%;
        width: 100%;
        display: flex;
        // background-color: #eeeeee;
        flex-direction: column;
        align-items: center;
        .tsbxc{
            width: calc(100% - 6%);
            .ygpjitem{
                margin-top: 15px;
                height: 100px;
                width: 100%;
                display: flex;
                background: #fff;
                flex-direction: column;
                border-radius: 10px;
                .ygpjup{
                    height: 40%;
                    border-bottom: 1px solid #f4f4f4;
                    display: flex;
                    align-items: center;
                    span{
                        margin-left: 20px;
                    }
                }
                .ygpjdown{
                    height: 60%;
                    display: flex;
                    align-items: center;
                    position: relative;
                    .dleft{
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        margin-left: 20px;
                        color: #999999;
                    }
                    .dpj{
                        height: 20px;
                        width: 60px;
                        top: calc(50% - 10px);
                        position: absolute;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        right: 5%;
                        border: 1px solid #00d2ff;
                        color: #00d2ff;
                        background-color: transparent;
                        border-radius: 30px;
                        font-size: 15px;
                    }
                }
            }
        }
    }
</style>